import { Injectable } from "@angular/core";

import { Subject } from "rxjs";

@Injectable()
export class ApprovedLockService {

    displayModal = new Subject<boolean>();

    showModal() {
        this.displayModal.next(true);
    }

    hideModal() {
        this.displayModal.next(false);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/approved-lock.service.ts